import { render, staticRenderFns } from "./AddTeamMembers.vue?vue&type=template&id=38894010&scoped=true"
import script from "./AddTeamMembers.vue?vue&type=script&lang=js"
export * from "./AddTeamMembers.vue?vue&type=script&lang=js"
import style0 from "./AddTeamMembers.vue?vue&type=style&index=0&id=38894010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38894010",
  null
  
)

export default component.exports